// Shimmer skeletons for loading states, replaces the bare "Loading…" text
// with placeholder blocks shaped like the content that's about to land, so
// the app reads as fast/native rather than blank-then-pop.
import type { CSSProperties } from "react";

export function Skeleton({
  width,
  height = 16,
  radius = 8,
  style,
}: {
  width?: number | string;
  height?: number | string;
  radius?: number;
  style?: CSSProperties;
}) {
  return (
    <span
      className="skeleton"
      style={{ width: width ?? "100%", height, borderRadius: radius, ...style }}
      aria-hidden
    />
  );
}

// Generic member-page skeleton: a title + subtitle, a primary card, and a
// few list rows. Mirrors the common venue-page layout closely enough to
// stand in for home / events / tickets / account while data loads.
export function PageSkeleton({ rows = 4 }: { rows?: number }) {
  return (
    <main className="main" aria-busy="true">
      <Skeleton width="55%" height={30} style={{ marginBottom: 12 }} />
      <Skeleton width="80%" height={14} style={{ marginBottom: 28 }} />
      <Skeleton height={92} radius={14} style={{ marginBottom: 16 }} />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton
          key={i}
          height={72}
          radius={14}
          style={{ marginBottom: 12 }}
        />
      ))}
    </main>
  );
}
